/**
 * @generated SignedSource<<234680382efb202cb15659b7fdaaff8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalStoreListItem_Signal$data = {
  readonly id: string;
  readonly store: {
    readonly id: string;
    readonly name: string;
    readonly timezone: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"SignalOpenedByEmployeeButton_signal">;
  readonly " $fragmentType": "WorkspaceSignalStoreListItem_Signal";
};
export type WorkspaceSignalStoreListItem_Signal$key = {
  readonly " $data"?: WorkspaceSignalStoreListItem_Signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalStoreListItem_Signal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalStoreListItem_Signal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignalOpenedByEmployeeButton_signal"
    }
  ],
  "type": "Signal",
  "abstractKey": null
};
})();

(node as any).hash = "f21e80f07613c49c36f4bde228683b4f";

export default node;
